import {
  UPDATE_ARTICLE_EVENT_SUCCESS,
  SET_ARTICLE_EVENTS,
} from 'config/constants';

const defaultState = {
  dislike_count: 0,
  like_count: 0,
};

export default (state = defaultState, action) => {
  const { type, event, articles } = action;
  switch (type) {
    case SET_ARTICLE_EVENTS:
      const { article } = event;

      return {
        dislike_count: article.dislike_count,
        like_count: article.like_count,
      };
    case UPDATE_ARTICLE_EVENT_SUCCESS:
      const { data, id } = articles;

      return {
        dislike_count: data.article.dislike_count,
        like_count: data.article.like_count,
      };
    default:
      return state;
  }
};
